module.exports = __webpack_public_path__ + "img/VIIcon.923d3f71.svg";